<template>
  <div id="wiper"></div>
</template>

<script>
import { TweenLite, Power4 } from "gsap";
export default {
  methods: {
    wipeIn() {
      var wiper = document.getElementById("wiper");
      TweenLite.set(wiper, { left: 0, right: "100%" });

      TweenLite.to(wiper, 0.8, { right: "-100px", ease: Power4.easeOut });
    },
    wipeOut() {
      var wiper = document.getElementById("wiper");
      TweenLite.to(wiper, 0.8, { left: "100%", ease: Power4.easeOut });
    }
  }
};
</script>

<style lang="scss" scoped>
#wiper {
  position: fixed;
  top: 100px;
  left: 0;
  right: 100%;
  bottom: 0;
  background-image: linear-gradient(to bottom right,  #111d3c,  #1a1818);
  z-index: 10;
  @media screen and (max-width: 768px) {
    top: 60px;
  }
}
</style>
